// noinspection ES6UnusedImports
import React, {useEffect, useState} from 'react';
import URL from '@core/scripts/helper/url';
import Messages from '@core/scripts/components/messages.js';
import MessageBroker from '@bonprix/pattern-library/components/message-broker.js';

export default function NitroTracker({
    nitroOptIn,
    nitroEcId,
    nitroEnvironmentName,
    trackingEnvironment,
    pageType,
    pageViewId,
}) {
    if (!nitroEnvironmentName) {
        return;
    }
    const testFilename = 'nitro_debug.js';
    const prodFilename = 'nitro.min.js';
    const fileName = trackingEnvironment === 'exec' ? prodFilename : testFilename;
    const resourcesPath = URL.toStaticResourcesRoot('/nitro');
    const nitroAssetLocation = URL.toAbsolute(resourcesPath);
    const assetLoadingPath = `${nitroAssetLocation}/${trackingEnvironment}/${fileName}`;

    const loadNitroScript = (optInOverride) => {
        const script = document.createElement('script');
        const scriptId = 'nitro-init';
        if (!document.getElementById(scriptId) && (nitroOptIn === 'true' || optInOverride)) {
            script.id = scriptId;
            script.src = assetLoadingPath;
            script.async = true;
            script.type = 'text/javascript';
            document.body.appendChild(script);
        }
    };

    // Adapting script to requirements
    window.nitroAssetLocation = nitroAssetLocation;
    window.nitroEnvironmentName = nitroEnvironmentName;
    window.nitroEcId = nitroEcId;

    useEffect(() => {
        const optInSubscription = MessageBroker.subscribe(Messages.OPTIN.MARKETING_STATUS_CHANGED, (payload) => {
            loadNitroScript(payload.optIn);
            if (nitroOptIn === 'false' && payload.optIn) {
                const eventPayload = {pageType: pageType, pageViewId: pageViewId};
                MessageBroker.publish(Messages.NITRO.LOADED, eventPayload);
            }
        });
        return () => {
            MessageBroker.unsubscribe(optInSubscription);
        };
    }, []);
    loadNitroScript(false);
}
